<app-loading-overlay [visible]="!showSelectAccountDialog()" />
<app-select-link-account-dialog
	[candidates]="candidates()"
	[loading]="isLinking()"
	[providerLabel]="providerLabel()"
	[visible]="showSelectAccountDialog()"
	(visibleChange)="showSelectAccountDialog.set($event)"
	(accountSelected)="onAccountSelected($event)"
	(cancelled)="onSelectionCancelled()"
/>
